import React from "react";
import DeleteNotification from "../components/DeleteNotification";
import NotificationCheckbox from "../components/NotificationCheckbox";
import NotificationClear from "../components/NotificationClear";
import CancelIcon from "@mui/icons-material/Cancel";
import NewReleasesIcon from "@mui/icons-material/NewReleases";

function NotificationPopup({ toggleNotification, notifications }) {
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // Use 24-hour format
    });
  };
  return (
    <div className="absolute right-0 top-16 bg-white shadow-lg rounded-lg p-4 z-30 ">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => toggleNotification()}
        />
      </div>
      <div className="flex justify-between">
        <h4 className="font-semibold">Notifications</h4> <NotificationClear />
      </div>

      {/* Add your notification items here */}
      {Array.isArray(notifications) && notifications.length > 0 ? (
        <div className="flex flex-col border-t border-gray-800 max-h-96 overflow-y-auto">
          {notifications.map((notification) => (
            <div
              key={notification?.id}
              className="flex justify-between gap-2 items-center border-b border-gray-800"
            >
              <div className="flex flex-col">
                <h3 className=" flex items-center text-lg font-semibold">
                  {notification?.notification?.title}
                  <NewReleasesIcon
                    className="text-yellow-400 "
                    sx={{ fontSize: 20 }}
                  />
                </h3>
                <h4 className="text-base">
                  {notification?.notification?.message}
                </h4>
              </div>
              <div className="flex flex-col">
                <div className="flex items-center">
                  {/* Checkbox and delete here */}
                  <NotificationCheckbox
                    notificationId={notification?.notification_id}
                    initiallyChecked={notification}
                  />
                  <DeleteNotification
                    notificationId={notification?.notification_id}
                  />
                </div>
                <div className="flex justify-end">
                  {/* Time stamp here */}
                  <h4 className="text-xs">
                    {formatTime(notification?.updated_at)}
                  </h4>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No new notifications.</p>
      )}
    </div>
  );
}

export default NotificationPopup;
